import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function Customers() {
  const [items, setItems] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.get("/customers").then((r) => setItems(r.data)); }, []);
  return (
    <div className="px-4 py-5 md:px-8 md:py-6">
      <div className="mb-4">
        <div className="text-[11px] uppercase tracking-[0.18em] mb-1" style={{ color: "var(--text-muted)" }}>Customer 360</div>
        <h1 className="font-display text-[24px]">Customers</h1>
      </div>
      <div className="card overflow-x-auto" data-testid="customers-table">
        <table className="w-full min-w-[640px] text-[12.5px]">
          <thead>
            <tr className="text-left" style={{ color: "var(--text-muted)", borderBottom: "1px solid var(--border)" }}>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Name</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Contact</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Plan</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Entitlement</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Billing</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">State</th>
              <th className="py-2 px-3 font-medium text-[11px] uppercase tracking-wider">Transaction</th>
            </tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} className="table-row cursor-pointer" style={{ borderBottom: "1px solid var(--border)" }}
                  onClick={() => nav(`/customers/${c.id}`)} data-testid={`customer-row-${c.id}`}>
                <td className="py-2.5 px-3 font-medium">{c.name}</td>
                <td className="py-2.5 px-3 font-mono text-[11px]" style={{ color: "var(--text-secondary)" }}>{c.email || c.phone}</td>
                <td className="py-2.5 px-3"><span className={`badge ${c.plan === "lifetime" ? "b-prod" : c.plan === "premium" ? "b-wait" : "b-muted"}`}>{c.plan}</span></td>
                <td className="py-2.5 px-3">{c.entitlement_active ? <span className="badge b-healthy">active</span> : <span className="badge b-rev">inactive</span>}</td>
                <td className="py-2.5 px-3">{c.billing_platform || "—"}</td>
                <td className="py-2.5 px-3">{c.subscription_state || "—"}</td>
                <td className="py-2.5 px-3 font-mono text-[11px]" style={{ color: "var(--text-muted)" }}>{c.transaction_id || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
